// Central localization resolver for restaurant-created content (products, categories, options).
// Serbian (`name`/`description`) is the canonical source of truth; English (`name_en`/`description_en`)
// is shown on /en when available, otherwise falls back to Serbian. Never affects IDs.
export function L(entity, locale, field = "name") {
  if (!entity) return "";
  if (locale === "en") return entity[`${field}_en`] || entity[field] || "";
  return entity[field] || "";
}

// Localize an array of option-name snapshots stored on cart/order items.
export function Lnames(sr, en, locale) {
  const src = locale === "en" && Array.isArray(en) && en.length ? en : sr;
  return Array.isArray(src) ? src : [];
}
